module.exports = __webpack_public_path__ + "static/media/helpdeskIcon.61eae69c.svg";